<script setup lang="ts">
import { Head } from "@inertiajs/vue3"
import { SbStatCard } from "@unio/saltbox-ui"

import DashboardNeedsAttention from "@/components/dashboard/DashboardNeedsAttention.vue"
import DashboardRecentContainers from "@/components/dashboard/DashboardRecentContainers.vue"
import DashboardRecentItems from "@/components/dashboard/DashboardRecentItems.vue"
import { useNavbar } from "@/composables/useNavbar"
import { ICON } from "@/lib/icons"
import type { ContainerSummary, ItemSummary } from "@/types/models"

const { title } = useNavbar({ title: "Dashboard" })

interface Props {
  stats: {
    total_items: number
    items_today: number
    total_containers: number
    needs_attention_count: number
  }
  recent_containers: ContainerSummary[]
  recent_items: ItemSummary[]
  items_without_photos: ItemSummary[]
  items_without_description: ItemSummary[]
}

defineProps<Props>()
</script>

<template>
  <Head :title="title" />

  <!-- Stats -->
  <div class="grid grid-cols-3 gap-2">
    <SbStatCard :value="stats.total_items" label="Items" :icon="ICON.item" bordered />
    <SbStatCard
      :value="stats.total_containers"
      label="Containers"
      :icon="ICON.container"
      bordered
    />
    <SbStatCard
      :value="stats.needs_attention_count"
      label="To Catalog"
      :icon="ICON.toCatalog"
      bordered
    />
  </div>

  <!-- Recents: side by side on desktop, stacked on mobile -->
  <div class="grid grid-cols-1 gap-4 lg:grid-cols-2 lg:gap-6">
    <DashboardRecentContainers :containers="recent_containers" />
    <DashboardRecentItems :items="recent_items" />
  </div>

  <!-- Needs attention -->
  <DashboardNeedsAttention
    :missing-photos="items_without_photos"
    :missing-descriptions="items_without_description"
  />
</template>
